import { useMutation, useQueryClient } from "@tanstack/react-query";
import momentsClient from "../../../../api/moments";
import { MOMENT_OCCASIONS_QUERY_KEY } from "./useMomentOccasionsQuery";

const useDeleteMomentOccasionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => momentsClient.deleteOccasion(key),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: MOMENT_OCCASIONS_QUERY_KEY }),
  });
};

export default useDeleteMomentOccasionMutation;
